import { render } from "./DialogSelectArea.vue?vue&type=template&id=0936d2be"
import script from "./DialogSelectArea.vue?vue&type=script&lang=js"
export * from "./DialogSelectArea.vue?vue&type=script&lang=js"

import "./DialogSelectArea.vue?vue&type=style&index=0&id=0936d2be&lang=scss"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__